module.exports = __webpack_public_path__ + "static/media/13.7545c583.jpg";